<template>
  <div>
    <v-btn @click="showCreateNoMatchDialog">Create No Match</v-btn>
    <NoMatchList 
      @reload="get" :nomatches="noMatches"/>
     <v-dialog
      v-model="dialog"
      max-width='400'
      transition="dialog-bottom-transition"
    >
      <v-card style="background-color: #f4f5f9;">
        <v-card-title>Create New No Match</v-card-title>
        <v-flex v-if="loadingEditBooking == true">
          <v-progress-linear indeterminate color="yellow darken-2"></v-progress-linear>
        </v-flex>
        <v-flex px-3 pa-1>
          <v-textarea placeholder="Description" v-model="description"/>
        </v-flex>
        <SelectableDriverUserInput
          :driver="driver"
          :user="user"
          @update="handleUpdate"
        />
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat text @click="dialog = false">Cancel</v-btn>
            <v-btn flat text @click="createNoMatch()">Create</v-btn>
          </v-card-actions>
          <v-progress-linear v-if="loadingRefund == true" indeterminate color="yellow darken-2"></v-progress-linear>
        </v-card>
      
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

import NoMatchList from "@/components/nomatch/NoMatchList.vue";

import SelectableDriverUserInput from "@/components/widget/input/SelectableDriverUserDropdownInputForNoMatch.vue";

export default {
  name: "no_match_panel",
  components: {
    NoMatchList,
    SelectableDriverUserInput
  },
  props: {
    driver: {
      type: Object,
      default: null,
    },
    user: {
      type: Object,
      default: null,
    }
  },
  data: function() {
    return {
      dialog: false,
      loading: false,
      noMatches: [],
      description: "",
      oppositeId: null,
    }
  },
  mounted: function() {
    this.get();
  },
  methods: {
    handleUpdate(id) {
      this.oppositeId = id;
    },
    showCreateNoMatchDialog() {
      this.description = ""
      this.dialog = true;
    },
    async get() {
      this.loading = true;

      var url = "";

      if (this.driver != null) {
        url = `${this.$store.state.apiUrl}/no_match/allForDriver?driver_id=${this.driver.id}`;
      } else {
        url = `${this.$store.state.apiUrl}/no_match/allForUser?user_id=${this.user.id}`;
      }

      try {
     
        let response = await axios.get(url, {
          params: {}
        });

        this.noMatches = response.data;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ratings " + error);
      }
    }, 
    async createNoMatch() {
      this.loading = true;

      var url = "";

      var self = this;

      if (this.driver != null) {
        url = `${this.$store.state.apiUrl}/no_match/create?driver_id=${this.driver.id}&user_id=${this.oppositeId}&description=${this.description}`;
      } else {
        url = `${this.$store.state.apiUrl}/no_match/create?user_id=${this.user.id}&driver_id=${this.oppositeId}&description=${this.description}`;
      }

      try {
     
        let response = await axios.post(url, {
          params: {}
        });

        var result = response.data;

        if (result.error == 'no_error') {
          self.get();
          self.dialog = false;
        } else {
          alert(result.error);
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ratings " + error);
      }
    },
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
